import script from "./PromoInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromoInput.vue?vue&type=script&lang=ts&setup=true"

import "./PromoInput.vue?vue&type=style&index=0&id=15145a56&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15145a56"]])

export default __exports__